import script from "./HowItWorksVouchersPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./HowItWorksVouchersPage.vue?vue&type=script&setup=true&lang=ts"

import "./HowItWorksVouchersPage.vue?vue&type=style&index=0&id=cc8f6efa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc8f6efa"]])

export default __exports__